import React, { useState, useEffect, useContext } from 'react'
import { InputAdornment, Tooltip } from '@mui/material'
import PostalCodeQuote from 'src/pages/Quotes/postalCodeQuote'
import LocationSet from 'src/pages/Quotes/locationSet'
import RangeKilometers from 'src/pages/Quotes/rangeKilometers'
import SpecificPrice from 'src/pages/Quotes/specificPrice'
import RangeTrips from 'src/pages/Quotes/rangeTrips'
import { AccountCircle } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { M_DrawerTableTextField, M_InputTextField, M_CheckBox, BufferService, LoadingContext, M_StateActions, NavigateContext } from '../M_Components'
import { useDispatch, useSelector } from 'react-redux'
import './quotesForm.css'

export default function QuotesForm() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [dataQuotes, setDataQuotes] = useState(new Map()) // onde está guardado as informações da Quote
    const [showFormTypeQuote, setShowFormTypeQuote] = useState(true)
    const [optionsForm, setOptionsForm] = useState([])
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [typeButton, setTypeButton] = useState('')
    const [quoteId, setQuoteId] = useState("")
    const [operation, setOperation] = useState("")
    const [rowCost, setRowCost] = useState([])
    const [count, setCount] = useState(1)

    // rangeKilometers
    const [tablesRange, setTablesRange] = useState([])
    const [optionsZone, setOptionsZone] = useState([])
    const [optionsRange, setOptionsRange] = useState([])
    const [firstRowAdded, setFirstRowAdded] = useState(false)

    //postal Code
    const [mapView, setMapView] = useState('streets-v11')
    const [zoomMap, setZoomMap] = useState(6)
    const [centerMap, setCenterMap] = useState([-8.0079, 39.5579])
    const [dataPostalCode, setDataPostalCode] = useState("")
    const [postalCode, setPostalCode] = useState([])
    const [disabled, setDisabled] = useState(true)
    const [optionsPostalCode, setOptionsPostalCode] = useState([])
    const [optionSelected, setOptionSelected] = useState('')

    // location set
    const [drawnFeatures, setDrawnFeatures] = useState([])
    const [drawPolygon, setDrawPolygon] = useState([])
    const [getCoordinates, setGetCoordinates] = useState(false)
    const [marker, setMarker] = useState([])
    const [teste, setTeste] = useState([])

    const bufferServicePricePlan = new BufferService('PricePlan')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const sessionKeys = ['dataQuotes', 'showFormTypeQuote', 'optionsForm', 'quoteId', 'operation', 'rowCost', 'tablesRange', 'optionsZone', 'optionsRange', 'firstRowAdded', 'mapView', 'zoomMap', 'centerMap', 'dataPostalCode', 'postalCode', 'disabled', 'optionsPostalCode', 'optionSelected', 'typeButton', 'drawnFeatures', 'drawPolygon', 'getCoordinates', 'marker', 'teste', 'count']

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, dataQuotes, showFormTypeQuote, optionsForm, quoteId, operation, rowCost, tablesRange, optionsZone, optionsRange, firstRowAdded, mapView, zoomMap, centerMap, dataPostalCode, postalCode, disabled, optionsPostalCode, optionSelected, typeButton, drawnFeatures, drawPolygon, getCoordinates, marker, teste, count])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempDQ = M_StateData.filter(obj => obj.key === `dataQuotes`)[0]?.value
            const tempSFTQ = M_StateData.filter(obj => obj.key === `showFormTypeQuote`)[0]?.value
            const tempOF = M_StateData.filter(obj => obj.key === `optionsForm`)[0]?.value
            const tempQI = M_StateData.filter(obj => obj.key === `quoteId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            const tempRC = M_StateData.filter(obj => obj.key === `rowCost`)[0]?.value
            const tempTR = M_StateData.filter(obj => obj.key === `tablesRange`)[0]?.value
            const tempOZ = M_StateData.filter(obj => obj.key === `optionsZone`)[0]?.value
            const tempOR = M_StateData.filter(obj => obj.key === `optionsRange`)[0]?.value
            const tempFR = M_StateData.filter(obj => obj.key === `firstRowAdded`)[0]?.value
            const tempSN = M_StateData.filter(obj => obj.key === `selectedTableName`)[0]?.value
            const tempMV = M_StateData.filter(obj => obj.key === `mapView`)[0]?.value
            const tempZM = M_StateData.filter(obj => obj.key === `zoomMap`)[0]?.value
            const tempCM = M_StateData.filter(obj => obj.key === `centerMap`)[0]?.value
            const tempDP = M_StateData.filter(obj => obj.key === `dataPostalCode`)[0]?.value
            const tempPC = M_StateData.filter(obj => obj.key === `postalCode`)[0]?.value
            const tempDI = M_StateData.filter(obj => obj.key === `disabled`)[0]?.value
            const tempOPC = M_StateData.filter(obj => obj.key === `optionsPostalCode`)[0]?.value
            const tempOS = M_StateData.filter(obj => obj.key === `optionSelected`)[0]?.value
            const tempTB = M_StateData.filter(obj => obj.key === `typeButton`)[0]?.value
            const tempDF = M_StateData.filter(obj => obj.key === `drawnFeatures`)[0]?.value
            const tempDW = M_StateData.filter(obj => obj.key === `drawPolygon`)[0]?.value
            const tempGC = M_StateData.filter(obj => obj.key === `getCoordinates`)[0]?.value
            const tempMK = M_StateData.filter(obj => obj.key === `marker`)[0]?.value
            const tempTE = M_StateData.filter(obj => obj.key === `teste`)[0]?.value
            const tempCT = M_StateData.filter(obj => obj.key === `count`)[0]?.value
            if (tempDQ || tempSFTQ || tempOF || tempQI || tempOP || tempRC || tempTR || tempOZ || tempOR || tempFR || tempSN || tempMV || tempZM || tempCM || tempDP || tempPC || tempDI || tempOPC || tempOS || tempTB || tempDF || tempDW || tempGC || tempMK || tempTE || tempCT) {
                setDataQuotes(new Map(tempDQ))
                setShowFormTypeQuote(tempSFTQ)
                setOptionsForm(tempOF)
                setQuoteId(tempQI)
                setOperation(tempOP)
                setRowCost(tempRC)
                setTablesRange(tempTR)
                setOptionsZone(tempOZ)
                setOptionsRange(tempOR)
                setFirstRowAdded(tempFR)
                setMapView(tempMV)
                setZoomMap(tempZM)
                setCenterMap(tempCM)
                setDataPostalCode(tempDP)
                setPostalCode(tempPC)
                setDisabled(tempDI)
                setOptionsPostalCode(tempOPC)
                setOptionSelected(tempOS)
                setTypeButton(tempTB)
                setDrawnFeatures(tempDF)
                setDrawPolygon(tempDW)
                setGetCoordinates(tempGC)
                setMarker(tempMK)
                setTeste(tempTE)
                setCount(tempCT)
                ctx.setIsLoad(false)
                return
            }
        }
        getQuote()
    }

    const getQuote = () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setQuoteId(getId)

        bufferServicePricePlan.options().then((optionsResponse) => {
            if (optionsResponse.name === 'AxiosError') {
                ctx.toastMessages('error', optionsResponse.response.data.Errors[0], '')
                return
            }
            setOptionsForm(optionsResponse)
            if (getOperation === 'edit') {
                bufferServicePricePlan.getId(getId).then((response) => {
                    if (response.name === 'AxiosError') {
                        ctx.toastMessages('error', response.response.data.Errors[0], '')
                        ctx2.closeTab(id)
                        return
                    }
                    const valueDataQuote = response
                    setRowCost(valueDataQuote['PricePlanExtraCostsList'])

                    optionsResponse.forEach(obj => {
                        dataQuotes.set(obj.Name, valueDataQuote[obj.Name])
                        if (obj.Type === "datetime") {
                            if (valueDataQuote[obj.Name] !== null) {
                                const dateValue = new Date(valueDataQuote[obj.Name])
                                const formattedDate = dateValue.toISOString().split('T')[0]
                                dataQuotes.set(obj.Name, formattedDate)
                            }
                        }
                        dataQuotes.set("Id", getId)
                    })
                    setDataQuotes(new Map(dataQuotes))
                    setTypeButton(t("Edit"))
                    ctx.setIsLoad(false)
                })
            } else if (getOperation === 'create') {
                setTypeButton(t("Add"))
                ctx.setIsLoad(false)
            }
        })
    }

    const addQuote = (event, index) => {
        if (event.type === "date") {
            const dateValue = new Date(event).toISOString().split("T")[0]
            dataQuotes.set(index, dateValue)
        } else {
            dataQuotes.set(index, event)
        }
        setDataQuotes(new Map(dataQuotes))
    }

    const submitQuote = () => {
        const requiredFields = optionsForm.filter((elem) => elem.IsRequired)
        for (const field of requiredFields) {
            if (field.Name !== 'PricePlanId') {
                if (!dataQuotes.has(field.Name) || !dataQuotes.get(field.Name)) {
                    ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                    return
                }
            }
        }

        console.log(dataQuotes)

        if (dataQuotes.get("TypeQuotes") === "Location Set") {
            const location = dataQuotes.get("Location")
            if (!dataQuotes.has("Location") || location == null || (Array.isArray(location) && location.length === 0) || (typeof location === "string" && location.trim() === "")) {
                ctx.toastMessages("error", "", t("DrawPolygonNecessary"))
                return
            }
        }

        ctx.setIsLoad(true)
        const tempObj = {}
        dataQuotes.set('PricePlanExtraCostsList', rowCost)
        dataQuotes.set('PriceTableList', tablesRange)
        setDataQuotes(new Map(dataQuotes))
        for (const [key, value] of dataQuotes) {
            tempObj[key] = value
        }

        if (operation === 'create') {
            bufferServicePricePlan.post(tempObj).then((response) => {
                if (response.name === "AxiosError") {
                    ctx.toastMessages('error', response.response.data.Errors[0], '')
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessCreateQuote"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServicePricePlan.update(tempObj.Id, tempObj).then((response) => {
                if (response.name === "AxiosError") {
                    ctx.setIsLoad(false)
                    ctx.toastMessages('error', response.response.data.Errors[0], '')
                    return
                }
                ctx.toastMessages("success", '', t("SuccessEditQuote"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    return (
        <>
            <div className="display" style={{ background: 'white', borderBottom: '2px solid var(--color-grey)' }}>
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-times iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Save")}>
                        <div className='iconsHeaderTable' onClick={submitQuote}>
                            <i className="pi pi-save iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                        </div>
                    </Tooltip>
                </div>
            </div>

            <div className='divGlobalFormQuotes'>
                <div className='divCardQuotes'>
                    <div className='divLabelQuotes'>
                        <img src="/icons/svgsDaNet/archive.svg"
                            style={{ width: '30px', marginRight: '10px', filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                            alt="Quotes" />
                        {t("Quote")}
                    </div>
                    <div className='divPrincipalFormQuotes'>
                        {optionsForm
                            .filter(
                                (elem) =>
                                    elem.IsHiddenList !== true &&
                                    (elem.Name !== 'AddressName' || dataQuotes.get("TypeQuotes") === 'Specific Price') &&
                                    (elem.Name !== 'CountryCode' ||
                                        dataQuotes.get("TypeQuotes") === 'Postal Code' ||
                                        dataQuotes.get("TypeQuotes") === 'Location Set')
                            )
                            .map((elem, key) => (
                                <div
                                    key={key}
                                    style={
                                        (elem.Name === 'IsEmptyContainer' ||
                                            elem.Name === 'NavCompany' ||
                                            elem.Name === 'Container' ||
                                            elem.Name === 'MinimunVoyages') &&
                                            dataQuotes.get("TypeQuotes") !== 'Transfer'
                                            ? { display: 'none' }
                                            : {}
                                    }
                                >
                                    {elem.Name === 'TimeChargeOrDischarge' && dataQuotes.get("TypeQuotes") === 'Transfer' ? null :
                                        elem.Name === 'MinimunVoyages' && !dataQuotes.get('IsEmptyContainer') ? null :
                                            elem.Type === 'string' ? (
                                                elem.IsForeignKey ? (
                                                    <M_DrawerTableTextField
                                                        tableLabel={elem.NormalizedName}
                                                        label={elem.NormalizedName}
                                                        required={elem.Required}
                                                        entity={elem.ForeignTableName}
                                                        value={dataQuotes.get(elem.ForeignTableToPassId) ?
                                                            {
                                                                [elem.ForeignTableToPassId]: dataQuotes.get(elem.ForeignTableToPassId),
                                                                [elem.ForeignKeyName]: dataQuotes.get(elem.Name)
                                                            } : null}
                                                        filterField={elem.ForeignKeyName}
                                                        labelFields={[elem.ForeignKeyName]}
                                                        onSubmitValue={obj => {
                                                            if (obj) {
                                                                dataQuotes.set(elem.Name, obj[elem.ForeignKeyName])
                                                                dataQuotes.set(elem.ForeignTableToPassId, obj[elem.ForeignTableToPassId])
                                                            } else {
                                                                dataQuotes.set(elem.Name, null)
                                                                dataQuotes.set(elem.ForeignTableToPassId, null)
                                                            }
                                                            setDataQuotes(new Map(dataQuotes))
                                                        }}
                                                        disabled={dataQuotes.get("TypeQuotes") === 'Specific Price' && elem.Name === 'AddressName' ? !dataQuotes.get("Customer") : false}
                                                        valueField={elem.ForeignTableToPassId}
                                                        filter={dataQuotes.get("TypeQuotes") === 'Specific Price' ? `EntityId eq ${dataQuotes.get("EntityId")}` : ''}
                                                    />
                                                ) : (
                                                    <M_InputTextField
                                                        type={'text'}
                                                        label={elem.NormalizedName}
                                                        color={'var(--color-red-dark)'}
                                                        onChange={(e) => addQuote(e.target.value, elem.Name)}
                                                        required={elem.IsRequired}
                                                        value={dataQuotes.get(elem.Name) || ''}
                                                    />
                                                )
                                            ) : elem.Type === 'datetime' ? (
                                                <M_InputTextField
                                                    type={'date'}
                                                    label={elem.NormalizedName}
                                                    color={'var(--color-red-dark)'}
                                                    onChange={(e) => addQuote(e.target.value, elem.Name)}
                                                    required={elem.IsRequired}
                                                    value={dataQuotes.get(elem.Name) || ''}
                                                />
                                            ) : elem.Type === 'boolean' ? (
                                                elem.Name === 'IsEmptyContainer' ? (
                                                    dataQuotes.get("TypeQuotes") === 'Transfer' && (
                                                        <div className='divCheckboxFormQuotes'>
                                                            <M_CheckBox
                                                                label={elem.NormalizedName}
                                                                onChange={(e) => addQuote(e.target.checked, elem.Name)}
                                                                color={'var(--color-red-dark)'}
                                                                checked={dataQuotes.get(elem.Name) || false}
                                                            />
                                                        </div>
                                                    )
                                                ) : (
                                                    <div className='divCheckboxFormQuotes'>
                                                        <M_CheckBox
                                                            label={elem.NormalizedName}
                                                            onChange={(e) => addQuote(e.target.checked, elem.Name)}
                                                            color={'var(--color-red-dark)'}
                                                            checked={dataQuotes.get(elem.Name) || false}
                                                        />
                                                    </div>
                                                )
                                            ) : elem.Type === 'decimal' ? (
                                                <M_InputTextField
                                                    type={'number'}
                                                    label={elem.NormalizedName}
                                                    color={'var(--color-red-dark)'}
                                                    onChange={(e) => addQuote(e.target.value, elem.Name)}
                                                    required={elem.IsRequired}
                                                    value={dataQuotes.get(elem.Name) || ''}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position='start'>
                                                                <AccountCircle />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            ) : elem.Type === 'int32' ? (
                                                <M_InputTextField
                                                    type={'number'}
                                                    label={elem.NormalizedName}
                                                    color={'var(--color-red-dark)'}
                                                    onChange={(e) => addQuote(e.target.value, elem.Name)}
                                                    required={elem.IsRequired}
                                                    value={dataQuotes.get(elem.Name) || ''}
                                                />
                                            ) : null}
                                </div>
                            ))}

                    </div>
                </div>
                {showFormTypeQuote && dataQuotes.get("TypeQuotes") && (
                    <div className="divFormTypeQuoteContainer">
                        {dataQuotes.get("TypeQuotes") === "Postal Code" && <PostalCodeQuote dataQuotes={dataQuotes} setDataQuotes={setDataQuotes} rowCost={rowCost} setRowCost={setRowCost} operation={operation} tablesRange={tablesRange} setTablesRange={setTablesRange} optionsZone={optionsZone} setOptionsZone={setOptionsZone} optionsRange={optionsRange} setOptionsRange={setOptionsRange} firstRowAdded={firstRowAdded} setFirstRowAdded={setFirstRowAdded} mapView={mapView} setMapView={setMapView} zoomMap={zoomMap} setZoomMap={setZoomMap} centerMap={centerMap} setCenterMap={setCenterMap} dataPostalCode={dataPostalCode} setDataPostalCode={setDataPostalCode} postalCode={postalCode} setPostalCode={setPostalCode} disabled={disabled} setDisabled={setDisabled} optionsPostalCode={optionsPostalCode} setOptionsPostalCode={setOptionsPostalCode} optionSelected={optionSelected} setOptionSelected={setOptionSelected} count={count} setCount={setCount} />}
                        {dataQuotes.get("TypeQuotes") === "Location Set" && <LocationSet dataQuotes={dataQuotes} setDataQuotes={setDataQuotes} rowCost={rowCost} setRowCost={setRowCost} operation={operation} tablesRange={tablesRange} setTablesRange={setTablesRange} optionsZone={optionsZone} setOptionsZone={setOptionsZone} optionsRange={optionsRange} setOptionsRange={setOptionsRange} firstRowAdded={firstRowAdded} setFirstRowAdded={setFirstRowAdded} mapView={mapView} setMapView={setMapView} zoomMap={zoomMap} setZoomMap={setZoomMap} centerMap={centerMap} drawnFeatures={drawnFeatures} setDrawnFeatures={setDrawnFeatures} drawPolygon={drawPolygon} setDrawPolygon={setDrawPolygon} getCoordinates={getCoordinates} setGetCoordinates={setGetCoordinates} marker={marker} setMarker={setMarker} teste={teste} setTeste={setTeste} count={count} setCount={setCount} />}
                        {dataQuotes.get("TypeQuotes") === "Range Kilometers" && <RangeKilometers dataQuotes={dataQuotes} setDataQuotes={setDataQuotes} rowCost={rowCost} setRowCost={setRowCost} operation={operation} tablesRange={tablesRange} setTablesRange={setTablesRange} optionsZone={optionsZone} setOptionsZone={setOptionsZone} optionsRange={optionsRange} setOptionsRange={setOptionsRange} firstRowAdded={firstRowAdded} setFirstRowAdded={setFirstRowAdded} count={count} setCount={setCount} />}
                        {dataQuotes.get("TypeQuotes") === "Specific Price" && <SpecificPrice dataQuotes={dataQuotes} setDataQuotes={setDataQuotes} rowCost={rowCost} setRowCost={setRowCost} operation={operation} tablesRange={tablesRange} setTablesRange={setTablesRange} optionsZone={optionsZone} setOptionsZone={setOptionsZone} optionsRange={optionsRange} setOptionsRange={setOptionsRange} firstRowAdded={firstRowAdded} setFirstRowAdded={setFirstRowAdded} count={count} setCount={setCount} />}
                        {dataQuotes.get("TypeQuotes") === "Transfer" && <RangeTrips dataQuotes={dataQuotes} setDataQuotes={setDataQuotes} rowCost={rowCost} setRowCost={setRowCost} operation={operation} tablesRange={tablesRange} setTablesRange={setTablesRange} optionsZone={optionsZone} setOptionsZone={setOptionsZone} optionsRange={optionsRange} setOptionsRange={setOptionsRange} firstRowAdded={firstRowAdded} setFirstRowAdded={setFirstRowAdded} count={count} setCount={setCount} />}
                    </div>
                )}
            </div>
        </>
    )
}
